import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private oidcSecurityService: OidcSecurityService;

  constructor(private injector: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestToForward = req;

    if (this.oidcSecurityService === undefined) {
      this.oidcSecurityService = this.injector.get(OidcSecurityService);
    }
    if (this.oidcSecurityService !== undefined) {
      let token: string | null = null;
      this.oidcSecurityService.getAccessToken().subscribe(tokenValue => token = tokenValue);
      if (token !== '') {
        const tokenValue = 'Bearer ' + token;
        requestToForward = req.clone({ setHeaders: { authorization: tokenValue } });
      }
    } else {
      // tslint:disable-next-line:no-console
      console.debug('OidcSecurityService undefined: NO auth header!');
    }

    return next.handle(requestToForward);
  }
}
